<template>
	<div class="_modal choose-popup bg-white">
		<div class="_modal__content px-12 py-6 sm-down:px-4">
			<div class="search-input w-full xl:max-w-lg mt-4">
				<div class="input-group">
					<input
						v-model="searchQuery"
						class="bg-white input-with-icon"
						placeholder="Tìm theo tên trung tâm"
						type="text"
						@keyup="searching"
						@keypress.enter="search"
					/>
					<div class="input-icon absolute top-1/2">
						<DaIcon
							class="h-4 w-4 text-neutral-400"
							name="das--search"
						/>
					</div>
				</div>
			</div>
			<div
				v-for="org in orgList"
				:key="org.org_id"
				class="flex justify-between items-start mt-8 flex-wrap gap-4"
			>
				<div class="flex items-start">
					<div
						v-if="org.org_id"
						class="flex flex-col gap-2 mr-4 md:mr-6 items-center"
						style="width: 111px"
					>
						<div :class="{ 'opacity-30': !org.is_active_org }">
							<img
								v-if="org?.profile_photo?.w200"
								:src="org?.profile_photo?.w200"
								alt=""
								class="
									shadow-sm
									inline-block
									h-16
									w-16
									rounded-2xl
								"
								style="max-width: 100%"
							/>
							<span
								v-else
								:style="{
									background:
										org?.profile_photo?.default?.color,
								}"
								class="
									inline-flex
									items-center
									justify-center
									h-16
									w-16
									rounded-2xl
								"
							>
								<span
									class="
										font-medium
										leading-none
										text-white text-4xl
									"
									>{{
										org?.profile_photo?.default?.initial
									}}</span
								>
							</span>
						</div>
						<div
							v-if="org.center_state === 'community'"
							class="
								text-gray-700 text-xs
								community
								flex
								items-center
								justify-center
							"
						>
							Gói Cộng Đồng
						</div>
					</div>
					<div class="flex-1" style="max-width: 150px">
						<div
							:class="{ 'opacity-30': !org.is_active_org }"
							class="font-semibold"
							:style="{ marginLeft: !org.org_id ? '25px' : null }"
						>
							{{ org.name }}
						</div>
						<div
							:class="{ 'opacity-30': !org.is_active_org }"
							class="truncate"
						>
							{{ org.address }}
						</div>
						<div
							:class="{ 'opacity-30': !org.is_active_org }"
							class="font-semibold"
						>
							{{ org.city }}
						</div>
						<div
							v-if="!org.is_active_org"
							class="flex items-center gap-2 mt-2"
						>
							<svg
								fill="none"
								height="13"
								viewBox="0 0 12 13"
								width="12"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									clip-rule="evenodd"
									d="M2.87497 4.94589V3.14587C2.87497 1.48897 4.27407 0.145996 6 0.145996C7.72593 0.145996 9.12503 1.48907 9.12503 3.14587V4.94589C10.1606 4.94589 11 5.75179 11 6.74592V10.346C11 11.3402 10.1606 12.146 9.12503 12.146H2.87497C1.83945 12.146 1 11.3402 1 10.346V6.74592C1 5.75179 1.83945 4.94589 2.87497 4.94589ZM7.87497 4.94589V3.14587C7.87497 2.15174 7.03552 1.34584 6 1.34584C4.96448 1.34584 4.12503 2.15174 4.12503 3.14587V4.94589H7.87497ZM6 7.34599C6.34518 7.34599 6.62495 7.61458 6.62495 7.94597V9.14602C6.62495 9.4774 6.34518 9.746 6 9.746C5.65482 9.746 5.37505 9.4774 5.37505 9.14602V7.94597C5.37505 7.61458 5.65482 7.34599 6 7.34599Z"
									fill="#E37056"
									fill-rule="evenodd"
								/>
							</svg>
							<span class="text-sm text-neutral-700"
								>Cơ sở đang khoá</span
							>
						</div>
					</div>
				</div>
				<div>
					<button
						v-if="
							htcs &&
							(org.org_id === selectedOrg?.org_id ||
								(!org.org_id && !selectedOrg))
						"
						class="button-p btn--ghost w-fit px-4 btn--sm"
						type="button"
					>
						<svg
							width="14"
							height="14"
							viewBox="0 0 14 14"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M9.75324 4.10668C9.83056 4.00359 9.80966 3.85734 9.70657 3.78002C9.60348 3.7027 9.45722 3.72359 9.3799 3.82668L5.3224 9.2367L2.70985 7.20472C2.60813 7.1256 2.46153 7.14392 2.38241 7.24565C2.3033 7.34737 2.32162 7.49396 2.42334 7.57308L5.22333 9.75085C5.27274 9.78928 5.33552 9.80625 5.39756 9.79794C5.4596 9.78963 5.5157 9.75674 5.55325 9.70667L9.75324 4.10668ZM11.5759 3.91223C11.4754 3.83738 11.3329 3.85829 11.2575 3.95813L7.30243 9.19837L7.15009 9.0802L6.88348 9.44641L7.20575 9.69641C7.25382 9.73357 7.31531 9.74929 7.37567 9.74134C7.43613 9.73329 7.49141 9.70195 7.52802 9.65345L11.6208 4.22864C11.696 4.12879 11.6763 3.98709 11.5759 3.91223Z"
								fill="#E5A42B"
							/>
							<path
								d="M9.70657 3.78002L9.55657 3.98002V3.98002L9.70657 3.78002ZM9.75324 4.10668L9.55324 3.95668V3.95668L9.75324 4.10668ZM9.3799 3.82668L9.1799 3.67668L9.1799 3.67668L9.3799 3.82668ZM5.3224 9.2367L5.16891 9.43404C5.22185 9.47521 5.28911 9.49339 5.35558 9.48449C5.42205 9.47559 5.48216 9.44035 5.5224 9.3867L5.3224 9.2367ZM2.70985 7.20472L2.86333 7.00738V7.00738L2.70985 7.20472ZM2.38241 7.24565L2.57975 7.39913L2.57975 7.39913L2.38241 7.24565ZM2.42334 7.57308L2.26986 7.77042H2.26986L2.42334 7.57308ZM5.22333 9.75085L5.37682 9.55351L5.37682 9.55351L5.22333 9.75085ZM5.39756 9.79794L5.36437 9.55015H5.36437L5.39756 9.79794ZM5.55325 9.70667L5.75325 9.85667V9.85667L5.55325 9.70667ZM11.2575 3.95813L11.4571 4.10874L11.4571 4.10873L11.2575 3.95813ZM11.5759 3.91223L11.7253 3.71179L11.7252 3.71175L11.5759 3.91223ZM7.30243 9.19837L7.14921 9.39591C7.20205 9.4369 7.26911 9.455 7.3354 9.44618C7.40169 9.43736 7.46169 9.40235 7.50197 9.34897L7.30243 9.19837ZM7.15009 9.0802L7.30331 8.88266C7.24987 8.84122 7.18193 8.82318 7.11497 8.83268C7.04802 8.84218 6.98777 8.87839 6.94797 8.93306L7.15009 9.0802ZM6.88348 9.44641L6.68137 9.29928C6.60185 9.4085 6.6235 9.56114 6.73025 9.64395L6.88348 9.44641ZM7.20575 9.69641L7.05251 9.89395L7.05285 9.89421L7.20575 9.69641ZM7.37567 9.74134L7.40831 9.9892L7.40865 9.98915L7.37567 9.74134ZM7.52802 9.65345L7.72757 9.80404L7.72759 9.80401L7.52802 9.65345ZM11.6208 4.22864L11.8204 4.37921L11.8205 4.37909L11.6208 4.22864ZM9.70657 3.78002L9.55657 3.98002C9.54921 3.97449 9.54771 3.96405 9.55324 3.95668L9.75324 4.10668L9.95324 4.25668C10.1134 4.04313 10.0701 3.74018 9.85657 3.58002L9.70657 3.78002ZM9.3799 3.82668L9.5799 3.97668C9.57438 3.98405 9.56393 3.98554 9.55657 3.98002L9.70657 3.78002L9.85657 3.58002C9.64302 3.41986 9.34007 3.46313 9.1799 3.67668L9.3799 3.82668ZM5.3224 9.2367L5.5224 9.3867L9.57991 3.97668L9.3799 3.82668L9.1799 3.67668L5.1224 9.0867L5.3224 9.2367ZM2.70985 7.20472L2.55636 7.40205L5.16891 9.43404L5.3224 9.2367L5.47588 9.03936L2.86333 7.00738L2.70985 7.20472ZM2.38241 7.24565L2.57975 7.39913C2.5741 7.4064 2.56363 7.40771 2.55636 7.40205L2.70985 7.20472L2.86333 7.00738C2.65263 6.84349 2.34896 6.88145 2.18508 7.09216L2.38241 7.24565ZM2.42334 7.57308L2.57683 7.37574C2.58409 7.38139 2.5854 7.39186 2.57975 7.39913L2.38241 7.24565L2.18508 7.09216C2.02119 7.30287 2.05915 7.60653 2.26986 7.77042L2.42334 7.57308ZM5.22333 9.75085L5.37682 9.55351L2.57683 7.37574L2.42334 7.57308L2.26986 7.77042L5.06985 9.94819L5.22333 9.75085ZM5.39756 9.79794L5.36437 9.55015C5.3688 9.54956 5.37329 9.55077 5.37682 9.55351L5.22333 9.75085L5.06985 9.94819C5.17219 10.0278 5.30223 10.0629 5.43074 10.0457L5.39756 9.79794ZM5.55325 9.70667L5.35325 9.55667C5.35593 9.55309 5.35994 9.55074 5.36437 9.55015L5.39756 9.79794L5.43074 10.0457C5.55925 10.0285 5.67546 9.9604 5.75325 9.85667L5.55325 9.70667ZM9.75324 4.10668L9.55324 3.95668L5.35325 9.55667L5.55325 9.70667L5.75325 9.85667L9.95324 4.25668L9.75324 4.10668ZM11.2575 3.95813L11.4571 4.10873C11.4501 4.11789 11.437 4.12053 11.4265 4.11272L11.5759 3.91223L11.7252 3.71175C11.5138 3.55423 11.2156 3.59869 11.058 3.80754L11.2575 3.95813ZM7.30243 9.19837L7.50197 9.34897L11.4571 4.10874L11.2575 3.95813L11.058 3.80753L7.10289 9.04776L7.30243 9.19837ZM7.15009 9.0802L6.99686 9.27775L7.14921 9.39591L7.30243 9.19837L7.45565 9.00082L7.30331 8.88266L7.15009 9.0802ZM6.88348 9.44641L7.0856 9.59355L7.3522 9.22734L7.15009 9.0802L6.94797 8.93306L6.68137 9.29928L6.88348 9.44641ZM7.20575 9.69641L7.35899 9.49888L7.03672 9.24888L6.88348 9.44641L6.73025 9.64395L7.05251 9.89395L7.20575 9.69641ZM7.37567 9.74134L7.34303 9.49348C7.34608 9.49307 7.35194 9.49344 7.35864 9.49862L7.20575 9.69641L7.05285 9.89421C7.1557 9.97371 7.28454 10.0055 7.40831 9.9892L7.37567 9.74134ZM7.52802 9.65345L7.32846 9.50285C7.33366 9.49596 7.3394 9.49396 7.34269 9.49352L7.37567 9.74134L7.40865 9.98915C7.53287 9.97262 7.64916 9.90794 7.72757 9.80404L7.52802 9.65345ZM11.6208 4.22864L11.4212 4.07807L7.32844 9.50288L7.52802 9.65345L7.72759 9.80401L11.8204 4.37921L11.6208 4.22864ZM11.5759 3.91223L11.4265 4.11268C11.415 4.10414 11.4136 4.08824 11.4211 4.07819L11.6208 4.22864L11.8205 4.37909C11.9785 4.16934 11.9376 3.87005 11.7253 3.71179L11.5759 3.91223Z"
								fill="#E5A42B"
							/>
						</svg>
						<div>Đang chọn</div>
					</button>
					<button
						v-else
						class="button-p btn--ghost w-fit px-4 btn--sm"
						type="button"
						@click="changeCenter(org)"
					>
						Chọn cơ sở
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Options, setup, Vue } from 'vue-class-component';
import { _var } from '@/enums/Common';
import { useStore } from 'vuex';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import { PropSync } from 'vue-property-decorator';

@Options({
	name: 'ChooseCenter',
	components: { DaIcon },
})
export default class ChooseCenter extends Vue {
	@PropSync('htcs', { type: Boolean, default: false })
	@PropSync('listCenter', { type: Array, default: [] })
	@PropSync('selectedOrg', { type: Object, default: null })
	setup = setup(() => {
		const store = useStore();
		return {
			store,
		};
	});

	typing = null;
	searchQuery = '';
	orgList = [];

	get orgs() {
		return this.setup.store.state.profile.orgs;
	}

	get staffOrg() {
		return this.setup.store.state.profile.current_org;
	}

	get centerState() {
		return this.setup.store.state.profile.center_state;
	}

	changeCenter(value) {
		if (this.htcs) {
			this.$emit('change-center', value);
		} else {
			const current = localStorage.getItem(_var.SUBDOMAIN);
			if (current !== value.subdomain) {
				localStorage.setItem(_var.SUBDOMAIN, value.subdomain);
				window.location.href = '/';
			}
		}
	}

	created() {
		if (this.htcs) {
			const orgIdSet = new Set(
				this.listCenter.map((item) => item.org_id).filter(Boolean)
			);
			this.orgList = this.orgs.filter((item) =>
				orgIdSet.has(item.org_id)
			);
			this.orgList.unshift({
				org_id: null,
				name: 'Hệ thống cơ sở',
				is_active_org: true,
			});
		} else this.orgList = this.orgs;
	}

	searching() {
		clearInterval(this.typing);
		this.typing = setTimeout(() => {
			this.search();
		}, 0);
	}

	async search() {
		this.orgList = this.orgs.filter((s) => {
			return (
				this.formatTextSearch(s.address).includes(
					this.formatTextSearch(this.searchQuery)
				) ||
				this.formatTextSearch(s.name).includes(
					this.formatTextSearch(this.searchQuery)
				) ||
				this.formatTextSearch(s.subdomain).includes(
					this.formatTextSearch(this.searchQuery)
				)
			);
		});
	}

	formatTextSearch(text) {
		if (!text) {
			return '';
		}
		return text.toLowerCase();
	}
}
</script>
<style scoped>
.community {
	background: #ede9fe;
	height: 24px;
	width: 111px;
	border-radius: 16px;
}
</style>
